'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
const Moment = require('moment');

const StringUtil = require('../../../../app/shared/StringUtil');

const propTypes = {
    editHref: PropTypes.string,
    editFunction: PropTypes.func,
    user: PropTypes.object.isRequired,
    userRole: PropTypes.string
};

const defaultProps = {
    editHref: '',
    userRole: '',
    editFunction: null
};

class UserListing extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let nameColContent;
        let _user = this.props.user;
        let userDisplayName;
        let verificationStatusElem = null;

        if (_user.unverified) {
            userDisplayName = '';
            verificationStatusElem = <em className="font-style-italic">Pending Member</em>;
        }
        else {
            userDisplayName = !!_user.first_name || !!_user.last_name ? `${_user.first_name} ${_user.last_name}` : _user.display_name; // org case
        }

        if (this.props.editHref) {
            nameColContent = (
                <Link to={this.props.editHref}>
                    {userDisplayName}
                    {verificationStatusElem}
                </Link>
            );
        }
        else if (this.props.editFunction) {
            nameColContent = (
                <button className="bare-text-button btn-link-plain" onClick={this.props.editFunction}>
                    {userDisplayName}
                    {verificationStatusElem}
                </button>
            );
        }
        else {
            nameColContent = (
                <div>
                    {userDisplayName}
                    {verificationStatusElem}
                </div>
            );
        }

        return (
            <tr className="user-listing">
                <td className="d-none d-sm-table-cell col-sm-1 cell">
                    <span className="fa fa-user" aria-hidden="true"/>
                </td>
                <td className="col-3 col-sm-2 cell">
                    {nameColContent}
                </td>
                <td className="col-2 cell">
                    {_user.email}
                </td>
                <td className="col-2 cell">
                    {this.props.userRole}
                </td>
                <td className="col-2 cell">
                    {!!_user.join_date ? Moment(_user.join_date).format('MM-DD-YYYY') : ''}
                </td>
                <td className="col-2 cell">
                    {!!_user.active_at ? Moment(_user.active_at).format('MM-DD-YYYY') : ''}
                </td>



            </tr>
        )
    }
}

UserListing.propTypes = propTypes;
UserListing.defaultProps = defaultProps;

export default UserListing;
